import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_2 = { class: "fw-700" }
const _hoisted_3 = ["data-dp-tooltip"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_ImageOverlayDetail = _resolveComponent("ImageOverlayDetail")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.overlays'),
        enabled: _ctx.enabled,
        name: _ctx.name,
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localDto, (_overlay, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "border rounded p-2 mb-2"
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('cms.overlay')) + " " + _toDisplayString(index + 1), 1),
                _createVNode(_component_BaseDeleteButton, {
                  deleteData: () => _ctx.removeOverlay(index),
                  pageUI: _ctx.componentUI,
                  class: "btn-sm"
                }, null, 8, ["deleteData", "pageUI"])
              ]),
              _createVNode(_component_ImageOverlayDetail, {
                modelValue: _ctx.localDto[index],
                "onUpdate:modelValue": [($event: any) => ((_ctx.localDto[index]) = $event), _ctx.emitModelChanged],
                name: `${_ctx.name} ${_ctx.$t('cms.overlay')} ${index + 1}`,
                errors: _ctx.errors
              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "errors"])
            ]))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-icon btn-primary",
            "data-dp-tooltip": _ctx.$t('cms.overlayAdd'),
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addOverlay && _ctx.addOverlay(...args)), ["prevent"]))
          }, _hoisted_5, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}